export enum AgeGroupEnum {
	OPEN = "OPEN",
	OVER = "OVER",
	UNDER = "UNDER"
}
